import Masonry from "masonry-layout";
import imagesLoaded from 'imagesloaded';

export default {
    masonry: null,
    loading: null,
    load() {
        window.clearTimeout(this.loading);
        this.loading = setTimeout(() => {
            const selector = !!document.querySelector('.home__tabs')
                ? '.home__tabs:not(.hidden) .cards'
                : '.cards';
            const container = document.querySelector(selector);
            if (!container) return;

            if (this.masonry && this.masonry.element === container) {
                // Re-scan DOM for new items, then reposition all
                this.masonry.reloadItems();
                this.masonry.layout();
            } else {
                if (this.masonry) this.masonry.destroy();
                this.masonry = new Masonry(container, {
                    percentPosition: true,
                    itemSelector: '.card',
                    transitionDuration: 0
                });
            }
        }, 66);
    },
    destroy() {
        if (this.masonry) {
            this.masonry.destroy();
            this.masonry = null;
        }
    },
    images() {
        const selector = !!document.querySelector('.home__tabs')
            ? '.home__tabs:not(.hidden) .cards'
            : '.cards';
        const container = document.querySelector(selector);
        if (!container) return;
        this.load();
        imagesLoaded(container, () => this.load());
    }
};
